export default function TranslateIcon({ className = ""}) {
  return (
    <svg
      className={className}
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 4.33357H16.8333M9.16667 1.04785V4.33357M13.5476 4.33357C12.0873 10.1748 8.80159 14.1907 3.69048 16.3812M5.88095 8.71452C7.34127 11.6352 9.53175 13.8256 12.4524 15.2859M13.5476 22.9526L19.0238 10.905L24.5 22.9526M22.9667 19.6669H15.081"
        stroke="#333333"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
